






































































































































































































































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { preferred_language } from "@/config/languags.config.json";
import { IExcursionCategory as ICategory } from "@/@types/excursions/excursions";
import { IExcursion } from "@/@types/excursions/excursions";
import { getMsTime } from "@/services/dateTime/pars-date-in-minutes";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import MainDemo from "@/components/demo/main-demo.vue";
import ExcursionMap from "@/components/card/excursion/excursion-map.vue";
import ExcursionDemo from "@/components/demo/excursion/excursion-demo.vue";
import ButtonLocales from "@/components/buttons/button-locales.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    btn: ChangeDeliteButtons,
    BSwitch,
    MainDemo,
    ExcursionMap,
    ExcursionDemo,
    "locale-btn": ButtonLocales,
  },
})
export default class FullExcursionCard extends Vue {
  @Prop({ type: Object, default: null }) card!: IExcursion;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;

  @Inject({ from: "excursionFolder", default: "" }) readonly folder!: string;
  @Inject({ from: "excursionBgFolder", default: "" }) readonly bg!: string;

  mapShow = false;
  showDemo = true;

  locale = preferred_language;

  get category(): ICategory | null {
    const cat = this.categorys.find((el) => el._id == this.card.category);
    return cat ? cat : null;
  }

  get duration(): { days: number; hours: number; minutes: number } {
    return getMsTime(this.card.duration);
  }
}
